import { YmAttrs } from '@/contracts/Ym'

export type ButtonAction = {
  id: string
  name: string
  label: string
  'id-label'?: string
  color: string
  type:
    | 'link'
    | 'switchLink'
    | 'scrollToContacts'
    | 'scrollToBuyByTelForm'
    | 'scrollToAgentsForm'
    | 'scrollToCallbackRegion'
    | 'openModal'
  url?: string
  'id-url'?: string
  padding: boolean
  arrow: boolean
  background?: string
  backgroundHover?: string
  borderColor?: string
  labelColor?: string
  labelHoverColor?: string
  borderRadius?: string
  modalBackground?: string
  modalRadius?: string
  modalBorder?: string
  modalText?: string
  jsCode?: string
  ymEvent: YmAttrs
  openInNewTab?: boolean
  icon?: string[]
  svgIcon?: string
}

export enum ButtonHeroActionType {
  NotSet = 'NotSet',
  BuyOnline = 'BuyOnline',
  RequestCall = 'RequestCall',
}
